<script setup>
import {defineProps} from "vue"
const props = defineProps({
  onShowingVideoDescription:{
    type:String,
  }
})
</script>

<template>
  <v-card elevation="0" class="register__classino__banner d-flex align-items-center justify-start " rounded="xl" >
    <img src="../../assets/images/default/live-classes/live%20white.gif" class="mx-5">
    <div class="class__information d-flex flex-column justify-center text-center align-center">
      <span class="font-weight-bold text-white">کلاس‌های زنده و رایگان</span>
      <p class="mt-3 text-white" v-if="onShowingVideoDescription">{{ onShowingVideoDescription }}</p>
      <p class="mt-3 text-white" v-else>دانش‌آموز عزیز در حال به‌روزرسانی سایت هستیم!<br> لطفا موقتا کلاس‌های خودتون رو از این صفحه مشاهده کنید.</p>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.register__classino__banner{
  width: 100%;
  border-radius: 25px;
  margin:auto;
  position: relative;
  background: url("@/assets/images/background/live-banner-desktop.png") no-repeat;
  background-size:cover;
  height: 230px;
  @include media-breakpoint-down(md){
    background: url("@/assets/images/background/live-banner-mobile.png") no-repeat;
    height: 160px;
    background-size: cover;
  }
  img{
    width: 130px;
    opacity: 0.5;
    @include media-breakpoint-down(md){
      width: 60px;
    }
  }
  .class__information{
    width: 100%;
    text-align:center ;
    position: absolute;
    span{
      font-size: 4rem;
      @include media-breakpoint-down(md){
        font-size: 1.3rem;
      }
    }
    p{
      line-height: 32px;
      max-width: 540px;
      @include media-breakpoint-down(md){
        font-size: 13px;
        max-width: 400px;
      }
    }

  }
}
</style>